<template>
  <div class="puppet-tab">
    <div class="slide">
      <div class="title">
        <img :src="title">
      </div>
      <GisBtn class="gisbtn" :gisurl="gisurl"></GisBtn>
    </div>
    <div class="list-wrapper">
      <ul class="tabnav-category" @click="$emit('showPicker')">
        <span>{{ $t("base.category") }}：</span>
        <li :class="{ active: !category }">{{ $t("base.allcategory") }}</li>
        <li class="active" v-if="category">{{ category }}</li>
      </ul>
      <Search
        :filterList="searchFilter"
        @search="subminSearch"
        @offsearch="offSearch"
      ></Search>
      <m-textArea class="data-list" ref="dataList">
        <div class="picture-list">
          <div
            v-for="(item, index) in datalist"
            :key="index"
            class="picture-item"
            @click="$emit('picshow', item)"
          >
            <div class="picture-main">
              <img :src="item.preview_url | picture" />
            </div>
            <div class="picture-tt">
              {{ item.title }}
            </div>
          </div>
        </div>
        <Pagination
          :num="pageNow"
          :pages="pages"
          @change="chagenPage"
        ></Pagination>
      </m-textArea>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Search from "@/components/Search.vue";
import GisBtn from "@/components/GisBtn.vue";
import TextArea from "@/components/TextArea";
import Pagination from "@/components/Pagination";

export default {
  props: {
    tabData: Object,
    category: String
  },
  components: {
    Search,
    GisBtn,
    "m-textArea": TextArea,
    Pagination
  },
  data() {
    return {
      pageName: "picture",
      onSearch: false,
      searchFilter: [
        { name: "title", title: "标题" },
        { name: "age", title: "年代" },
        { name: "region", title: "地域" },
        { name: "material", title: "材质" },
        { name: "keywords", title: "关键词" },
        { name: "comment", title: "简介" }
      ],
      searchParam: {},
      gisurl:
        "http://amap.zju.edu.cn/maps/3275/mobile?from=timeline&isappinstalled=0"
    };
  },
  computed: {
    ...mapState(["picture"]),
    datalist() {
      if (this.onSearch) {
        return this.picture.searchres.content;
      }
      return this.picture[this.pageNow];
    },
    pageNow() {
      return this.onSearch
        ? this.picture.searchres.number
        : this.picture.number;
    },
    pages() {
      return this.onSearch
        ? this.picture.searchres.total_pages
        : this.picture.total_pages;
    },
    title() {
      return this.tabData.ttimg;
    }
  },
  mounted() {
    this.getPageData();
  },
  filters: {
    picture(value) {
      return value.replace("210.33.124.164:8080/pms", "shadow.caa.edu.cn/py");
    }
  },
  watch: {
    category: function(c, oldc) {
      if (c === oldc) {
        return;
      }
      this.subminSearch(this.searchParam);
    }
  },
  methods: {
    ...mapActions(["getDataList", "searchData"]),
    getPageData(page_num = 0) {
      const param = {
        data_name: this.pageName,
        page_size: 24,
        page_num
      };
      if (this.category) {
        param.category = this.category;
      }
      this.getDataList(param);
    },
    chagenPage(num) {
      this.onSearch
        ? this.search(this.searchParam, num)
        : this.getPageData(num);
      this.$refs.dataList.scroll();
    },
    search(param, num = 0) {
      const query = {
        data_name: this.pageName,
        page_size: 24,
        page_num: num,
        ...param
      };
      if (this.category) {
        query.category = this.category;
      }
      this.searchData(query);
      this.searchParam = param;
      this.onSearch = true;
    },
    subminSearch(data) {
      this.search(data);
      this.$refs.dataList.scroll();
    },
    offSearch() {
      this.getPageData();
      this.onSearch = false;
      this.searchParam = {};
      this.$refs.dataList.scroll();
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.puppet-tab {
  position: relative;
  display: flex;
  height: 73vh;
  padding: 1rem 1rem 0;
  overflow: hidden;

  .slide {
    position: relative;
    flex: 1;

    .title {
      position: absolute;
      top: 3rem;
      @include scaleimg(0.5);
    }

    .gisbtn {
      position: absolute;
      left: 0.5rem;
      bottom: 1rem;
    }
  }

  .list-wrapper {
    flex: 5;
    display: flex;
    flex-direction: column;
  }

  .tabnav-category {
    margin: 0;
    padding: 0 0.5rem 0.5rem;
    font-size: 0.875rem;

    li {
      display: none;
      padding: 0 0.5rem;
      line-height: 1.2;

      &.active {
        display: inline-block;
        color: $primary;
        font-weight: 700;
      }

      &:first-child {
        margin-left: -0.75rem;
      }

      &::after {
        content: "";
        display: inline-block;
        margin-top: 0.35rem;
        margin-left: 0.5rem;
        width: 0.5rem;
        height: 0.3rem;
        background-image: url("~@/assets/img/arrow-down.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        vertical-align: top;
      }
    }
  }

  .data-list {
    flex: 1;
    margin-top: 1rem;

    .text-main {
      padding: 0 0 1rem;
    }
  }

  .picture-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 1rem;
    padding: 0 0.5rem;
  }

  .picture-item {
    width: 48%;
    margin-bottom: 0.65rem;
    padding: 0.5rem;
    background-color: #d2c2a3;

    .picture-main {
      height: 6rem;
      text-align: center;
      line-height: 6rem;
      img {
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
    }

    .picture-tt {
      font-size: 0.75rem;
      text-align: center;
    }
  }
}
</style>
